import React, { useState } from "react";
import { Button, Drawer } from "antd";
import { useNavigate } from "react-router-dom";
import SocialModal from "./SocialModal";

const CustomDrawer = () => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  return (
    <>
      <Button type="primary" onClick={showDrawer}>
        Menu
      </Button>
      <Drawer
        title="Shravan Meena"
        placement="right"
        onClose={onClose}
        visible={open}
      >
        <p
          onClick={() => {
            onClose();
            navigate("/");
          }}
        >
          Home
        </p>
        <p
          onClick={() => {
            onClose();
            navigate("/blog");
          }}
        >
          Blog
        </p>
        <p
          onClick={() => {
            onClose();
            navigate("/video");
          }}
        >
          Videos
        </p>

        <SocialModal>
          <Button type="primary" onClick={showDrawer}>
            Let's chat
          </Button>
        </SocialModal>
      </Drawer>
    </>
  );
};

export default CustomDrawer;
